import * as u from "react";
import { useState as ce } from "react";
var C = function() {
  return C = Object.assign || function(t) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (t[o] = r[o]);
    }
    return t;
  }, C.apply(this, arguments);
};
function q(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
}
function ie(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, o; n < a; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var x = "right-scroll-bar-position", I = "width-before-scroll-bar", ue = "with-scroll-bars-hidden", le = "--removed-body-scroll-bar-size";
function Y(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function fe(e, t) {
  var r = ce(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(n) {
          var a = r.value;
          a !== n && (r.value = n, r.callback(n, a));
        }
      }
    };
  })[0];
  return r.callback = t, r.facade;
}
var se = typeof window < "u" ? u.useLayoutEffect : u.useEffect, G = /* @__PURE__ */ new WeakMap();
function de(e, t) {
  var r = fe(null, function(n) {
    return e.forEach(function(a) {
      return Y(a, n);
    });
  });
  return se(function() {
    var n = G.get(r);
    if (n) {
      var a = new Set(n), o = new Set(e), l = r.current;
      a.forEach(function(c) {
        o.has(c) || Y(c, null);
      }), o.forEach(function(c) {
        a.has(c) || Y(c, l);
      });
    }
    G.set(r, e);
  }, [e]), r;
}
function ve(e) {
  return e;
}
function he(e, t) {
  t === void 0 && (t = ve);
  var r = [], n = !1, a = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    },
    useMedium: function(o) {
      var l = t(o, n);
      return r.push(l), function() {
        r = r.filter(function(c) {
          return c !== l;
        });
      };
    },
    assignSyncMedium: function(o) {
      for (n = !0; r.length; ) {
        var l = r;
        r = [], l.forEach(o);
      }
      r = {
        push: function(c) {
          return o(c);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(o) {
      n = !0;
      var l = [];
      if (r.length) {
        var c = r;
        r = [], c.forEach(o), l = r;
      }
      var p = function() {
        var v = l;
        l = [], v.forEach(o);
      }, g = function() {
        return Promise.resolve().then(p);
      };
      g(), r = {
        push: function(v) {
          l.push(v), g();
        },
        filter: function(v) {
          return l = l.filter(v), r;
        }
      };
    }
  };
  return a;
}
function me(e) {
  e === void 0 && (e = {});
  var t = he(null);
  return t.options = C({ async: !0, ssr: !1 }, e), t;
}
var $ = function(e) {
  var t = e.sideCar, r = q(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = t.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return u.createElement(n, C({}, r));
};
$.isSideCarExport = !0;
function ge(e, t) {
  return e.useMedium(t), $;
}
var J = me(), j = function() {
}, D = u.forwardRef(function(e, t) {
  var r = u.useRef(null), n = u.useState({
    onScrollCapture: j,
    onWheelCapture: j,
    onTouchMoveCapture: j
  }), a = n[0], o = n[1], l = e.forwardProps, c = e.children, p = e.className, g = e.removeScrollBar, v = e.enabled, s = e.shards, d = e.sideCar, w = e.noRelative, b = e.noIsolation, i = e.inert, f = e.allowPinchZoom, h = e.as, m = h === void 0 ? "div" : h, S = e.gapMode, E = q(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), y = d, R = de([r, t]), k = C(C({}, E), a);
  return u.createElement(
    u.Fragment,
    null,
    v && u.createElement(y, { sideCar: J, removeScrollBar: g, shards: s, noRelative: w, noIsolation: b, inert: i, setCallbacks: o, allowPinchZoom: !!f, lockRef: r, gapMode: S }),
    l ? u.cloneElement(u.Children.only(c), C(C({}, k), { ref: R })) : u.createElement(m, C({}, k, { className: p, ref: R }), c)
  );
});
D.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
D.classNames = {
  fullWidth: I,
  zeroRight: x
};
var ye = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function pe() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = ye();
  return t && e.setAttribute("nonce", t), e;
}
function we(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Se(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var be = function() {
  var e = 0, t = null;
  return {
    add: function(r) {
      e == 0 && (t = pe()) && (we(t, r), Se(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Ce = function() {
  var e = be();
  return function(t, r) {
    u.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, ee = function() {
  var e = Ce(), t = function(r) {
    var n = r.styles, a = r.dynamic;
    return e(n, a), null;
  };
  return t;
}, Ee = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, V = function(e) {
  return parseInt(e || "", 10) || 0;
}, Re = function(e) {
  var t = window.getComputedStyle(document.body), r = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" : "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [V(r), V(n), V(a)];
}, ke = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Ee;
  var t = Re(e), r = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, n - r + t[2] - t[0])
  };
}, Ae = ee(), N = "data-scroll-locked", Me = function(e, t, r, n) {
  var a = e.left, o = e.top, l = e.right, c = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(ue, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(c, "px ").concat(n, `;
  }
  body[`).concat(N, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(n, ";"),
    r === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(l, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(c, "px ").concat(n, `;
    `),
    r === "padding" && "padding-right: ".concat(c, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(x, ` {
    right: `).concat(c, "px ").concat(n, `;
  }
  
  .`).concat(I, ` {
    margin-right: `).concat(c, "px ").concat(n, `;
  }
  
  .`).concat(x, " .").concat(x, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(I, " .").concat(I, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(N, `] {
    `).concat(le, ": ").concat(c, `px;
  }
`);
}, Q = function() {
  var e = parseInt(document.body.getAttribute(N) || "0", 10);
  return isFinite(e) ? e : 0;
}, Pe = function() {
  u.useEffect(function() {
    return document.body.setAttribute(N, (Q() + 1).toString()), function() {
      var e = Q() - 1;
      e <= 0 ? document.body.removeAttribute(N) : document.body.setAttribute(N, e.toString());
    };
  }, []);
}, Ne = function(e) {
  var t = e.noRelative, r = e.noImportant, n = e.gapMode, a = n === void 0 ? "margin" : n;
  Pe();
  var o = u.useMemo(function() {
    return ke(a);
  }, [a]);
  return u.createElement(Ae, { styles: Me(o, !t, a, r ? "" : "!important") });
}, F = !1;
if (typeof window < "u")
  try {
    var W = Object.defineProperty({}, "passive", {
      get: function() {
        return F = !0, !0;
      }
    });
    window.addEventListener("test", W, W), window.removeEventListener("test", W, W);
  } catch {
    F = !1;
  }
var A = F ? { passive: !1 } : !1, Te = function(e) {
  return e.tagName === "TEXTAREA";
}, te = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !Te(e) && r[t] === "visible")
  );
}, We = function(e) {
  return te(e, "overflowY");
}, Be = function(e) {
  return te(e, "overflowX");
}, _ = function(e, t) {
  var r = t.ownerDocument, n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var a = re(e, n);
    if (a) {
      var o = ne(e, n), l = o[1], c = o[2];
      if (l > c)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== r.body);
  return !1;
}, Le = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    r,
    n
  ];
}, Oe = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    r,
    n
  ];
}, re = function(e, t) {
  return e === "v" ? We(t) : Be(t);
}, ne = function(e, t) {
  return e === "v" ? Le(t) : Oe(t);
}, xe = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Ie = function(e, t, r, n, a) {
  var o = xe(e, window.getComputedStyle(t).direction), l = o * n, c = r.target, p = t.contains(c), g = !1, v = l > 0, s = 0, d = 0;
  do {
    if (!c)
      break;
    var w = ne(e, c), b = w[0], i = w[1], f = w[2], h = i - f - o * b;
    (b || h) && re(e, c) && (s += h, d += b);
    var m = c.parentNode;
    c = m && m.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? m.host : m;
  } while (
    // portaled content
    !p && c !== document.body || // self content
    p && (t.contains(c) || t === c)
  );
  return (v && Math.abs(s) < 1 || !v && Math.abs(d) < 1) && (g = !0), g;
}, B = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, K = function(e) {
  return [e.deltaX, e.deltaY];
}, U = function(e) {
  return e && "current" in e ? e.current : e;
}, De = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Xe = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Ye = 0, M = [];
function je(e) {
  var t = u.useRef([]), r = u.useRef([0, 0]), n = u.useRef(), a = u.useState(Ye++)[0], o = u.useState(ee)[0], l = u.useRef(e);
  u.useEffect(function() {
    l.current = e;
  }, [e]), u.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var i = ie([e.lockRef.current], (e.shards || []).map(U), !0).filter(Boolean);
      return i.forEach(function(f) {
        return f.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), i.forEach(function(f) {
          return f.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var c = u.useCallback(function(i, f) {
    if ("touches" in i && i.touches.length === 2 || i.type === "wheel" && i.ctrlKey)
      return !l.current.allowPinchZoom;
    var h = B(i), m = r.current, S = "deltaX" in i ? i.deltaX : m[0] - h[0], E = "deltaY" in i ? i.deltaY : m[1] - h[1], y, R = i.target, k = Math.abs(S) > Math.abs(E) ? "h" : "v";
    if ("touches" in i && k === "h" && R.type === "range")
      return !1;
    var z = window.getSelection(), X = z && z.anchorNode, oe = X ? X === R || X.contains(R) : !1;
    if (oe)
      return !1;
    var T = _(k, R);
    if (!T)
      return !0;
    if (T ? y = k : (y = k === "v" ? "h" : "v", T = _(k, R)), !T)
      return !1;
    if (!n.current && "changedTouches" in i && (S || E) && (n.current = y), !y)
      return !0;
    var Z = n.current || y;
    return Ie(Z, f, i, Z === "h" ? S : E);
  }, []), p = u.useCallback(function(i) {
    var f = i;
    if (!(!M.length || M[M.length - 1] !== o)) {
      var h = "deltaY" in f ? K(f) : B(f), m = t.current.filter(function(y) {
        return y.name === f.type && (y.target === f.target || f.target === y.shadowParent) && De(y.delta, h);
      })[0];
      if (m && m.should) {
        f.cancelable && f.preventDefault();
        return;
      }
      if (!m) {
        var S = (l.current.shards || []).map(U).filter(Boolean).filter(function(y) {
          return y.contains(f.target);
        }), E = S.length > 0 ? c(f, S[0]) : !l.current.noIsolation;
        E && f.cancelable && f.preventDefault();
      }
    }
  }, []), g = u.useCallback(function(i, f, h, m) {
    var S = { name: i, delta: f, target: h, should: m, shadowParent: Ve(h) };
    t.current.push(S), setTimeout(function() {
      t.current = t.current.filter(function(E) {
        return E !== S;
      });
    }, 1);
  }, []), v = u.useCallback(function(i) {
    r.current = B(i), n.current = void 0;
  }, []), s = u.useCallback(function(i) {
    g(i.type, K(i), i.target, c(i, e.lockRef.current));
  }, []), d = u.useCallback(function(i) {
    g(i.type, B(i), i.target, c(i, e.lockRef.current));
  }, []);
  u.useEffect(function() {
    return M.push(o), e.setCallbacks({
      onScrollCapture: s,
      onWheelCapture: s,
      onTouchMoveCapture: d
    }), document.addEventListener("wheel", p, A), document.addEventListener("touchmove", p, A), document.addEventListener("touchstart", v, A), function() {
      M = M.filter(function(i) {
        return i !== o;
      }), document.removeEventListener("wheel", p, A), document.removeEventListener("touchmove", p, A), document.removeEventListener("touchstart", v, A);
    };
  }, []);
  var w = e.removeScrollBar, b = e.inert;
  return u.createElement(
    u.Fragment,
    null,
    b ? u.createElement(o, { styles: Xe(a) }) : null,
    w ? u.createElement(Ne, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function Ve(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const He = ge(J, je);
var Fe = u.forwardRef(function(e, t) {
  return u.createElement(D, C({}, e, { ref: t, sideCar: He }));
});
Fe.classNames = D.classNames;
var ze = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, P = /* @__PURE__ */ new WeakMap(), L = /* @__PURE__ */ new WeakMap(), O = {}, H = 0, ae = function(e) {
  return e && (e.host || ae(e.parentNode));
}, Ze = function(e, t) {
  return t.map(function(r) {
    if (e.contains(r))
      return r;
    var n = ae(r);
    return n && e.contains(n) ? n : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, Ge = function(e, t, r, n) {
  var a = Ze(t, Array.isArray(e) ? e : [e]);
  O[r] || (O[r] = /* @__PURE__ */ new WeakMap());
  var o = O[r], l = [], c = /* @__PURE__ */ new Set(), p = new Set(a), g = function(s) {
    !s || c.has(s) || (c.add(s), g(s.parentNode));
  };
  a.forEach(g);
  var v = function(s) {
    !s || p.has(s) || Array.prototype.forEach.call(s.children, function(d) {
      if (c.has(d))
        v(d);
      else
        try {
          var w = d.getAttribute(n), b = w !== null && w !== "false", i = (P.get(d) || 0) + 1, f = (o.get(d) || 0) + 1;
          P.set(d, i), o.set(d, f), l.push(d), i === 1 && b && L.set(d, !0), f === 1 && d.setAttribute(r, "true"), b || d.setAttribute(n, "true");
        } catch (h) {
          console.error("aria-hidden: cannot operate on ", d, h);
        }
    });
  };
  return v(t), c.clear(), H++, function() {
    l.forEach(function(s) {
      var d = P.get(s) - 1, w = o.get(s) - 1;
      P.set(s, d), o.set(s, w), d || (L.has(s) || s.removeAttribute(n), L.delete(s)), w || s.removeAttribute(r);
    }), H--, H || (P = /* @__PURE__ */ new WeakMap(), P = /* @__PURE__ */ new WeakMap(), L = /* @__PURE__ */ new WeakMap(), O = {});
  };
}, _e = function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), a = ze(e);
  return a ? (n.push.apply(n, Array.from(a.querySelectorAll("[aria-live], script"))), Ge(n, a, r, "aria-hidden")) : function() {
    return null;
  };
};
export {
  Fe as R,
  _e as h
};
